import { render, staticRenderFns } from "./leftNav.vue?vue&type=template&id=28494235&scoped=true"
import script from "./leftNav.vue?vue&type=script&lang=js"
export * from "./leftNav.vue?vue&type=script&lang=js"
import style0 from "./leftNav.vue?vue&type=style&index=0&id=28494235&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28494235",
  null
  
)

export default component.exports